import React from 'react';
import { useBlotterConfigurationSelector } from 'widgets/blotter/store/configuration/selectors';

import ColumnPortfolio, {
    applyCurrency,
    BlotterColumn,
    BlotterColumns,
} from 'widgets/blotter/columns/ColumnPortfolio';
import {
    ColumnPickerModal,
    PickableItem,
} from '@instinet-analytics/semantic-ui-components';
import { useDispatchUpdateVisibleColumns } from 'widgets/store/grid/visibleColumns/dispatcher';
import { initialBlotterConfiguration } from 'widgets/blotter/store/configuration/BlotterConfiguration';
import { useAppCurrency } from 'app/store/selectors';
import { useSelectAppSettings } from 'app/store/appSettings/selectors';
import { useWidgetEditedColumnNames } from 'grid/columnNames/hooks';

export interface BlotterColumnsModalProps {
    columnPortfolio: ColumnPortfolio;
    blotterId: string;
}

export default function BlotterColumnsModal(props: BlotterColumnsModalProps) {
    const { blotterId, columnPortfolio } = props;

    const { visibleColumns } = useBlotterConfigurationSelector(blotterId);
    const currency = useAppCurrency();
    const { currencyCode } = useSelectAppSettings();
    const prefix = currency?.prefix ?? currencyCode;

    const { editedColumnNames } = useWidgetEditedColumnNames();

    const allPickableItems: PickableItem<BlotterColumn>[] = Object.values(
        columnPortfolio
    ).map((column) => {
        const colWithCurrenciesApplied = applyCurrency(column, prefix);

        const haveEditedName =
            editedColumnNames[column.id] &&
            editedColumnNames[column.id].trim() !== column.name.trim();

        return {
            value: colWithCurrenciesApplied.id,
            desc: colWithCurrenciesApplied.desc,
            name: haveEditedName ? editedColumnNames[column.id] : column.name,
            nameSuffix: haveEditedName ? column.name : undefined,
            tag: colWithCurrenciesApplied.tag,
        };
    });

    const dispatchUpdateVisibleColumns = useDispatchUpdateVisibleColumns();

    const onUpdateVisibleColumns = (cols: BlotterColumn[]) => {
        dispatchUpdateVisibleColumns(cols);
    };

    const onUpdateSelectedValues = (values: BlotterColumns) => {
        onUpdateVisibleColumns(values);
    };

    return (
        <ColumnPickerModal
            triggerClassName="BlotterColumnsModalTrigger"
            selectedValues={visibleColumns}
            allItems={allPickableItems}
            defaultSelectedValues={initialBlotterConfiguration.visibleColumns}
            onUpdateSelectedValues={onUpdateSelectedValues}
        />
    );
}
